import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../services/app.service';
//import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-configure',
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit {
  connecting:boolean = false;
  code_error:boolean= false;
  name_error:boolean= false;
  connecting_error:boolean = false;
  connecting_msg:string = '';
  MACHINE_ID:any = '';
  constructor(private router:Router,private appservice:AppService ) { 
      this.MACHINE_ID = this.appservice.getMachineId();
//      translate.setDefaultLang('en');
  }

  ngOnInit() {
  }


  loadScreen(code,name){
    if(code == ''){
      this.code_error = true;
      return false;
    }
    if(name == ''){
      this.name_error = true;
      return false;
    }
    this.connecting = true;
    this.appservice.connectScreen(code,name,(result)=>{
      if(typeof(result.status) != 'undefined' && result.status == 'OK'){
          this.router.navigate(['/streaming/'+result.data.screen_id]);
      }else{
        
        this.connecting_error = true;
        this.connecting_msg = result.message;
        this.connecting = false;
      }
    });

    
    
  }


}



// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/components/configure/configure.component.ts